(function () {

  'use strict';

  /**
    Configuration and requirements
    // note, that this directive acts as a container for other directives,
    //and it is responible connect the contained directive with eachother and with the controller
    -----------------
    popupObject: {
      dimensions: { height: number, widht: number}, //
      offset: { top: number, left: number}, // this is used to offset the popup relative its parent
      pointerDirection: null, // this will be set dynamically
      pointerPosition: string, // supports => right, left, center, up, middle, bottom
      relativePosition: string, // supports => over, under, left, right (note: left + left is not possible)
      type: string, // supports => SIMPLE_SELECT, COMBINED_SELECT_INPUT
      title: string,
      confirmText: string,
      cancelText: string
    }
    childDirectiveDataObject {}
    // this object is passed along to the directives the subDirectives, we support ['pxSelect', 'pxInput']
    // for specific requirements goto the .js files and read the documentation
  */

  function popupGenerelPurpose($timeout, CopilotService) {
    return {
      restrict: 'EA',
      scope: {
        childDirectiveDataObject: '=childDirectiveDataObject',
        popupObject: '=popupObject',
        clearPopup: '&clearPopup',
        callback: '&callback'
      },
      templateUrl: 'app/directives/popupGenerelDirective/popup-generel-purpose.template.html',
      link: function (scope, element) {

        scope.subDirectiveData = scope.childDirectiveDataObject;
        scope.confirmEnabled = false;
        scope.title = scope.popupObject.title;
        scope.confirmText = scope.popupObject.confirmText;
        scope.cancelText = scope.popupObject.cancelText;
        scope.pointerDistance = 5;
        scope.resetPagination = false;
        scope.checkboxValue  = null;

        scope.$watch(function () {
          return scope.data;
        }, function () {
          setDimensions();
        }, true);

        scope.$watch(function () {
          return scope.childDirectiveDataObject;
        }, function () {
          scope.subDirectiveData = scope.childDirectiveDataObject;
        }, true);

        function setDimensions() {
          const element = angular.element('.pop-up-container');
          element.css({ width: scope.popupObject.dimensions.width });
          scope.popupObject.dimensions.height = undefined;
          setPositionRelative();
        }

        function setPositionRelative() {
          $timeout(function () {
            const element = angular.element('.pop-up-container');
            const height = scope.popupObject.dimensions.height || element[0].clientHeight;
            const heightOfParent = element.parent().parent().parent()[0].clientHeight;
            switch (scope.popupObject.relativePosition) {
              case 'over':
                element.css({ top: scope.popupObject.absoluteY - height });
                setPositionRelativeHorizontal();
                break;
              case 'under':
                element.css({ top: scope.popupObject.absoluteY });
                setPositionRelativeHorizontal();
                break;
              case 'middle':
                element.css({ top: scope.popupObject.absoluteY / 2 });
                setPositionRelativeHorizontal();
                break;
              case 'left':
                element.css({ left: scope.popupObject.absoluteX - (scope.popupObject.dimensions.width + scope.popupObject.offset.left) });
                setPositionRelativeVertical(heightOfParent);
                break;
              case 'right':
                element.css({ left: scope.popupObject.absoluteX + scope.popupObject.offset.left });
                setPositionRelativeVertical(heightOfParent);
                break;
              case 'none':
                showPopup();
                break;
            }
          }, 100);
        }

        function setPositionRelativeHorizontal() {
          $timeout(function () {
            const element = angular.element('.pop-up-container');
            switch (scope.popupObject.pointerPosition) {
              case 'right':
                element.css({ left: scope.popupObject.absoluteX + scope.popupObject.offset.left - scope.popupObject.dimensions.width });
                break;
              case 'left':
                element.css({ left: scope.popupObject.offset.left });
                break;
              case 'center':
                element.css({ left: (scope.popupObject.offset.left - scope.popupObject.dimensions.width) / 2 });
                break;
              default:
                element.css({ left: (scope.popupObject.offset.left - scope.popupObject.dimensions.width) / 2 });
                break;
            }
            showPopup();
          }, 100);
        }

        function setPositionRelativeVertical(heightOfParent) {
          $timeout(function () {
            const element = angular.element('.pop-up-container');
            const height = scope.popupObject.dimensions.height || element[0].clientHeight;
            switch (scope.popupObject.pointerPosition) {
              case 'up':
                element.css({ top: scope.popupObject.absoluteY - scope.popupObject.offset.top });
                break;
              case 'middle':
                element.css({ top: scope.popupObject.absoluteY - height / 2 + scope.popupObject.offset.top });
                break;
              case 'bottom':
                element.css({ top: heightOfParent / 2 - height });
                break;
            }
            showPopup();
          }, 100);
        }

        function showPopup() {
          const element = angular.element('.pop-up-container');
          element.show();
          element.addClass('openPopup');
        }

        scope.closePopup = function () {
          const element = angular.element('.pop-up-container');
          element.hide();
          element.removeClass(scope.popupObject.type);
          scope.resetPagination = true;
          scope.clearPopup();
        };

        scope.closePopupOutside = function () {
          // Don't close the dialog on outside click if the copilot window is open and configured
          // because the user might want to interact with the copilot window.
          const copilotOpenAndEnabled = CopilotService.state.chatOpen && CopilotService.state.configured;
          if (scope.popupObject.clickOutsideToClose && !copilotOpenAndEnabled) {
            angular.element('.pop-up-container').hide();
            angular.element('.pop-up-container').removeClass(scope.popupObject.type);
            scope.resetPagination = true;
            scope.clearPopup();
          }
        };

        scope.popupOverride = function (enableParentClickOutside) {
          scope.popupObject.clickOutsideToClose = enableParentClickOutside;
        };

        scope.selectedItem = function (item, enableConfirm, selectedAttachmentItem) {
          setConfirm(enableConfirm);
          scope.selectAttachedItem = selectedAttachmentItem;
          scope.selectItem = item;
        };

        scope.inputSelectItem = function (item, enableConfirm) {
          setConfirm(enableConfirm);
          scope.inputItem = item;
        };

        scope.setInputItem = function (item, enableConfirm) {
          setConfirm(enableConfirm);
          scope.inputItem = item;
        };

        scope.setCheckboxValue = function (value) {
          scope.checkboxValue = value;
        };

        function setConfirm(enableConfirm) {
          scope.confirmEnabled = !!enableConfirm;
        }

        scope.confirm = function (boolean) {
          switch (scope.popupObject.type) {
            case 'SIMPLE_SELECT':
              scope.callback({ item: scope.selectItem });
              break;
            case 'PAGINATION':
              scope.callback({ item: scope.selectItem });
              break;
            case 'PAGINATION_ATTACHED_SELECT':
              scope.callback({ item: scope.selectItem, attachedItem: scope.selectAttachedItem });
              break;
            case 'SIMPLE_INPUT':
              scope.callback({ item: scope.inputItem });
              break;
            case 'COMBINED_SELECT_INPUT':
              scope.callback({ item: scope.inputItem });
              break;
            case 'SIMPLE_INPUT_AND_CHECKBOX':
              scope.inputItem.checkboxValue = scope.checkboxValue;
              scope.callback({ item: scope.inputItem });
              break;
            case 'MASS_DISTRIBUTION':
              scope.callback({ item: scope.selectItem });
              break;
            case 'SNMP_FORMS':
              scope.callback({ item: scope.selectItem });
              break;
            case 'CHANGE_DRIVER_CONFIG':
              scope.callback({ item: scope.selectItem });
              break;
            case 'CONFIRM':
              if (boolean) {
                scope.callback();
              }
              break;
            case 'SELECT_SNMP':
              scope.callback({ item: scope.selectItem });
              break;
            case 'SELECT_NETWORK_AND_SNMP':
              scope.callback({ item: scope.selectItem, attachedItem: scope.selectAttachedItem });
              break;
          }
          scope.clearPopup();
        };

        element.on('keydown keypress', function (event) {
          if (event.which === 13) {
            scope.$apply(function () {
              if (scope.confirmEnabled) {
                scope.confirm();
              }
            });
            event.preventDefault();
          }
        });

      }
    };
  }

  popupGenerelPurpose.$inject = ['$timeout', 'CopilotService'];

  angular
    .module('printix-admin')
    .directive('popupGenerelPurpose', popupGenerelPurpose);

})();
